module.exports = __webpack_public_path__ + "static/elegy-for-the-end-a42668bddbd36dc17cf235fb5284055f.png";